// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { triangle } from 'polished';

type Props = {
  name: string,
  selected: string,
  disabled?: boolean,
  options: Array<{
    label: string | null,
    value: string,
    disabled?: boolean,
  }>,

  onChange?: (value: string) => any,
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 43px;
  box-sizing: border-box;
  min-width: 260px;
  border-radius: 4px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #e3e4eb;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: block;
    width: 28px;
    border-left: solid 1px #e3e4eb;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 10px;
    margin-top: -2px;
    opacity: 0.4;

    ${triangle({
      pointingDirection: 'bottom',
      foregroundColor: 'black',
      width: 7,
      height: 6,
    })};
  }

  ${ifProp(
    'disabled',
    css`
      opacity: 0.7;
      cursor: not-allowed;
    `,
  )};
`;

const Select = styled.select`
  appearance: none;
  border: none;
  background: none;

  display: block;
  width: 100%;
  padding: 10px 15px;
  margin: 0;
  line-height: 14.4px;
  font-size: 14.4px;
  color: #3c4042;
  opacity: 0.7;
  box-sizing: border-box;

  ${ifProp(
    'disabled',
    css`
      cursor: not-allowed;
    `,
  )};
`;

const Dropdown = (props: Props) => (
  <Wrapper disabled={props.disabled}>
    <Select
      name={props.name}
      onChange={(e: SyntheticInputEvent<HTMLInputElement>) => {
        props.onChange && props.onChange(e.currentTarget.value);
      }}
      disabled={props.disabled}
    >
      {props.options.map(option => {
        return (
          <option
            key={option.value}
            value={option.value}
            selected={option.value === props.selected}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        );
      })}
    </Select>
  </Wrapper>
);

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js